module.exports = __webpack_public_path__ + "static/img/keshi2.f7a10aec.webp";